export default __webpack_public_path__ + "assets/bookmark1.4f004021.gif";